module.exports = __webpack_public_path__ + "static/media/groceries.2bb89650.png";